export default "__VITE_ASSET__CUNdy$HS__"